import {Injectable} from '@angular/core';
import {IEmailConfirmationFilter} from "../interfaces/IEmailConfirmationFilter";
import {APIService} from "./api.service";
import {HttpParams} from "@angular/common/http";
import {IEmailConfirmationPagedResponse} from "../interfaces/IEmailConfirmationPagedResponse";
import {createStore, select, setProp, withProps} from "@ngneat/elf";
import {setEntities, withEntities} from "@ngneat/elf-entities";
import {IEmailConfirmation} from "../interfaces/IEmailConfirmation";
import {map} from "rxjs";
import {GameService} from "./game.service";

@Injectable({
  providedIn: 'root'
})
export class EmailConfirmationService {

  private defaultEmailConfirmationResponse: IEmailConfirmationPagedResponse = {
    Data: [],
    Errors: [],
    FirstPage: 1,
    LastPage: 1,
    Message: "",
    NextPage: "",
    PageNumber: 1,
    PageSize: 1,
    PreviousPage: "",
    Succeeded: false,
    TotalPages: 1,
    TotalRecords: 0
  };

  private emailConfirmationStore = createStore(
    {name: 'email-confirmation-response'},
    withProps<{
      emailConfirmationResponse: IEmailConfirmationPagedResponse
    }>({emailConfirmationResponse: this.defaultEmailConfirmationResponse}),
    withEntities<IEmailConfirmation, "Id">({idKey: "Id"})
  );

  public emailConfirmations$ = this.emailConfirmationStore.pipe(select(state => state.emailConfirmationResponse));

  constructor(private apiService: APIService, private gameService: GameService) { }

  public getEmailConfirmations(filterP: IEmailConfirmationFilter)
  {
    let params =  new HttpParams();

    if (this.gameService.activeGame()){
      params = params.append('gameId', this.gameService.activeGame().Id);
    }

    if (filterP.email) {
      params = params.append('email', filterP.email);
    }

    if (filterP.type != null) {
      params = params.append('type', filterP.type);
    }

    if (filterP.confirmed != null) {
      params = params.append('confirmed', filterP.confirmed);
    }

    if (filterP.fromDate) {
      params = params.append('fromDate', filterP.fromDate);
    }

    if (filterP.toDate) {
      params = params.append('toDate', filterP.toDate);
    }

    if (filterP.pageNumber) {
      params = params.append('pageNumber', filterP.pageNumber);
    }

    if (filterP.pageSize) {
      params = params.append('pageSize', filterP.pageSize);
    }

    return this.apiService.MakeGetRequest<IEmailConfirmationPagedResponse>("email-confirmation/search", params).pipe(map((response) => {
      this.emailConfirmationStore.update(setProp('emailConfirmationResponse', response));
      this.emailConfirmationStore.update(setEntities(response.Data));
      return response.Data;
  }));
  }
}
